import React from 'react';
import { IconButton, Tooltip, Zoom } from '@material-ui/core';
import { SyncDisabled } from '@material-ui/icons';

type RevertButtonProps = {
  onRevert: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disableTooltip?: boolean;
  tabIndex?: number | undefined;
};

export const RevertButton = ({ onRevert, disableTooltip, tabIndex }: RevertButtonProps): JSX.Element => {
  const component = (
    <IconButton size="small" onClick={onRevert} data-testid="override-revert-button" tabIndex={tabIndex}>
      <SyncDisabled fontSize="small" />
    </IconButton>
  );

  return disableTooltip ? (
    component
  ) : (
    <Tooltip
      data-testid="override-revert-button-tooltip"
      title={'Revert'}
      placement="top"
      arrow
      TransitionComponent={Zoom}
    >
      {component}
    </Tooltip>
  );
};
